module.exports = __WEBPACK_EXTERNAL_MODULE_22__;


//////////////////
// WEBPACK FOOTER
// external "isogd-dossier-rest"
// module id = 22
// module chunks = 0